module.exports = __webpack_public_path__ + "static/media/Shreyas.3359cef9.png";